var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.structureLoadingState === "done"
        ? _c(
            "div",
            [
              _c("courseware-search-results", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showSearchResults,
                    expression: "showSearchResults",
                  },
                ],
              }),
              _vm._v(" "),
              _c("courseware-structural-element", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.showSearchResults,
                    expression: "!showSearchResults",
                  },
                ],
                attrs: {
                  canVisit: _vm.canVisit,
                  "structural-element": _vm.selected,
                  "ordered-structural-elements": _vm.orderedStructuralElements,
                },
                on: {
                  select: _vm.selectStructuralElement,
                },
              }),
              _vm._v(" "),
              _c(
                "MountingPortal",
                {
                  attrs: {
                    mountTo: "#courseware-action-widget",
                    name: "sidebar-actions",
                  },
                },
                [
                  !_vm.showSearchResults && _vm.canEditSelected
                    ? _c("courseware-action-widget", {
                        attrs: {
                          "structural-element": _vm.selected,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "MountingPortal",
                {
                  attrs: {
                    mountTo: "#courseware-search-widget",
                    name: "sidebar-search",
                  },
                },
                [
                  _vm.selected !== null
                    ? _c("courseware-search-widget")
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.structureLoadingState === "loading"
        ? _c("studip-progress-indicator", {
            staticClass: "loading-indicator-content",
            attrs: {
              description: _vm.$gettext("Lade Lernmaterial..."),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.structureLoadingState === "error"
        ? _c("courseware-companion-box", {
            attrs: {
              mood: "sad",
              msgCompanion: _vm.loadingErrorMessage,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "companionActions",
                  fn: function fn() {
                    return [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.rootElementUrl,
                          },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "button",
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$gettext("Erste Seite aufrufen")) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3735924967
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _c("courseware-companion-overlay"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }